module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/ts-loader/index.js??ruleSet[1].rules[1].use[0]!./license-owners-list.ts"));
	}, "license-owners-module");
}